import { Box } from "@mui/material";
import { AdminSubscriptionDetailResponseDeliveryDaysEnum } from "../../openapi/client";
import { DAY_LIST } from "../../utils";
import moment from "moment";

interface IProps {
  deliveryDays?: AdminSubscriptionDetailResponseDeliveryDaysEnum[];
}

export default function DeliveryDays(props: IProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "4px",
      }}
    >
      {DAY_LIST.map((i) => {
        const active = props.deliveryDays?.includes(i as AdminSubscriptionDetailResponseDeliveryDaysEnum)
          ? "active"
          : "";
        return (
          <Box
            className={`${active}`}
            sx={{
              borderRadius: "6px",
              padding: "8px",
              width: "40px",
              backgroundColor: "text.light3",
              color: "text.dark2",
              fontSize: "10px",
              fontWeight: 500,
              lineHeight: "12px",
              textAlign: "center",
              "&.active": { backgroundColor: "primary.main", color: "white" },
            }}
          >
            {moment(i.toLocaleLowerCase(), "dddd").format("ddd")}
          </Box>
        );
      })}
    </Box>
  );
}
